import React from 'react'

import { useCreateTemplateRecord } from './_requests/createTemplateRecord'
import { useModalData } from '../../../components/modals/ModalsContext'
import Form from '../../../packages/kiti/components/form/form/Form'
import FormItem from '../../../packages/kiti/components/form/form/FormItem'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import TemplateSelect from '../../../containers/templates/select/TemplateSelect'

const CreateTemplateRecordForm = () => {
  const { entity, checklistIds } = useModalData()
  const [onSubmit, { loading, error }] = useCreateTemplateRecord()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={{}}>
      <FormItem
        label="Template*"
        field="template"
        Input={TemplateSelect}
        filter={{ entities: entity, checklistIds, includeChecklistIdNil: true }}
      />
      <SubmitBar loading={loading} error={error} label="Gerar" />
    </Form>
  )
}

export default CreateTemplateRecordForm
